<template>
<div>

    <div class="box partner-box" style="display: grid; place-items: center;" @click="partner_modal = true">
        <img src="https://assets.webbank.com/partners/dell.jpg" style="max-width: 75%;" alt="Dell Logo">
    </div>

<div class="modal" :class="{'is-active': partner_modal}">
  <div class="modal-background"></div>
  <div class="modal-content">
      <div class="box has-text-left">
          <h2 class="box-title">Our Brand Partner</h2>
          <br>
          <div style="display: grid; place-items: center;">
            <img src="https://assets.webbank.com/partners/dell.jpg" style="max-width: 200px;" alt="Dell Logo">
          </div>
            <br>
            <p>Eligible Dell Preferred Accounts issued by WebBank transitioned to a new payment solution for all of your Dell purchases, Dell Pay Credit issued by Comenity Capital Bank on October 4, 2023.  Dell Pay will continue to offer the same seamless financing experience and all the same great benefits you've come to expect from your Dell Preferred Account.  If you have any questions, please call 1-866-395-9796 or TDD/TTY: 1-888- 819-1918.</p>
            <br>
            <p>Visit Account Center at <a href="#" title="Dell.com/ManageDellPay" @click="$emit('link-click', 'https://d.comenity.net/ac/dellpay/public/home')">Dell.com/ManageDellPay</a> for online account management.</p>

            <br>
            <p><a href="#" title="Dell Credit Agreement" @click="$emit('link-click', 'https://www.dell.com/en-us/learn/preferred-account/credit-agreement')">Dell Preferred Account Cardholder Agreement</a></p>
            <br>
            <p><a href="#" title="Dell Financial Services Privacy Policy" @click="$emit('link-click', 'https://www.dell.com/learn/us/en/uscorp1/policies-privacy')">Dell Financial Services Privacy Policy</a></p>
            <br>

            <button class="button is-primary is-light" @click="partner_modal = false">Close</button>

      </div>
  </div>
  <button class="modal-close is-large" aria-label="close" @click="partner_modal = false"></button>
</div>

</div>
</template>

<script>
export default {
    data: function () {
        return {
            partner_modal: false,
        }
    }
}
</script>
